export const UserAccountType = {
  Anonymous: 'Anonymous',
  Guest: 'Guest',
  Editor: 'Editor',
  Admin: 'Admin',
  SuperAdmin: 'SuperAdmin',
}
